type MoneyProps = {
  sign?: string;
  delimiter?: string;
  decimal?: string;
  append?: boolean;
  precision?: number;
  round?: boolean;
  custom?: any;
};

// higher order function that takes options then a price and will return the formatted price
export const formatCurrency =
  ({ sign = 'R$ ', delimiter = '.', decimal = ',', append = false, precision = 2, round = true, custom }: MoneyProps = {}) =>
  (value: any) => {
    const e = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000];

    value = round ? Math.round(value * e[precision]) / e[precision] : parseFloat(value);

    const pieces = value.toFixed(precision).replace('.', decimal).split('');

    let ii = pieces.length - (precision ? precision + 1 : 0);

    while ((ii -= 3) > 0) {
      pieces.splice(ii, 0, delimiter);
    }

    if (typeof custom === 'function') {
      return custom({
        sign,
        float: value,
        value: pieces.join(''),
      });
    }

    return append ? pieces.join('') + sign : sign + pieces.join('');
  };

export const brazilianRealFormat = formatCurrency();

export const clearCurrencyToNumber = (currency: any): number => {
  let response = `${currency}`;
  response = response.replaceAll(',', '_');
  response = response.replaceAll('.', '');
  response = response.replaceAll('_', '.');

  return Number(response);
};
